// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'circle-solid';

export const Component = () => (
  <path
    fill='currentColor'
    stroke='currentColor'
    d='M.563 9a8.437 8.437 0 1 0 16.874 0A8.437 8.437 0 0 0 .562 9z'
  />
);

export const viewBox = '0 0 18 18';
